// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"697":"c1e35734739bc181","2888":"2adb24ea6814b717"}[chunkId] + ".css";
};